import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { v_LocationDetailBus } from './v_LocationDetailBus';
import { DateFunctions } from '../static/date-functions';

export class DQOIErrorBus extends BaseBus
{
    constructor(data: DQOIErrorBus) {
        super(data);
    }
    CID(): any {
        return this.errorId;
    }
    setId(id: any) {
        this.errorId = id;
    }
    setParentId(id: any) {
        this.referenceId = id;
    }
    initialize(data: DQOIErrorBus) {
    super.initialize(data);
    try {
      this.insertDt = CommonFunctions.getDate(data.insertDt);
      this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    catch {

    }

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
       // this.insertDt = date;
       // this.insertUserId = userId;
    }
    setFromForm(data: DQOIErrorBus) {
        super.setFromForm(data);
      }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    errorId: any;
    categoryId: any;
    referenceId: any;
    categoryName: string;
    categoryDescription: string;
    comments: string;
    userName: string;
    whoEnteredName: string;
    personId: any;
    insertUserId: any;
    insertDt: Date;
    updateUserId: any;
    updateDt: Date;
}
